"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Dashboard = _interopRequireDefault(require("./Dashboard.js"));
exports.default = _Dashboard.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }